import { Dropdown, Form, Grid, Input, Text } from '@wework/dieter-ui'
import { withFloorMap } from '@wework/react-floormap'

import React from 'react'
import SATextHolder from '../EditPanel/SATextHolder'

function SpaceType({
  space,
  floorMap,
  setRoomData,
  roomData,
  isChair = false,
}: any) {
  if (!space) {
    return <></>
  }
  if (!roomData) {
    return <></>
  }

  let options = []
  const labelKey = 'name'
  const valueKey = 'roomType'
  const types = floorMap?.extensions.classification.getRoomTypes()

  options =
    types &&
    types.map(option => {
      return {
        key: option[valueKey],
        value: option[valueKey].toUpperCase(),
        text: option[labelKey],
      }
    })

  return (
    <>
      <Grid.Row stretched>
        <Grid.Column>
          <div>
            <Text style={{ fontWeight: 'bold', fontSize: 16 }}>Space</Text>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <div>
            <SATextHolder
              title="Space name"
              text="What is the name of this physical space? This is what we show on the floorplan."
            />
          </div>
        </Grid.Column>
        <Grid.Column width={8}>
          <Form.Field
            control={Input}
            outline
            label="Name"
            defaultValue={roomData?.office_number}
            value={roomData?.office_number}
            onChange={(e, data) => {
              setRoomData({
                ...roomData,
                office_number: data?.value,
              })
            }}
            options={options}
          />
          {/* <Text size="tiny">
            Reference: Space ID <b>{roomData.number}</b>
          </Text> */}
        </Grid.Column>
      </Grid.Row>
      {!isChair && (
        <Grid.Row>
          <Grid.Column width={8}>
            <div>
              <SATextHolder
                title="Space type"
                text="What kind of space is this?"
              />
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Form.Field
              control={Dropdown}
              outline
              defaultValue={roomData?.room_type?.toUpperCase()}
              search
              value={roomData?.room_type?.toUpperCase()}
              onChange={(e, data) => {
                const selectedType = types.find(
                  type =>
                    //@ts-ignore
                    type.roomType.toLowerCase() === data.value.toLowerCase()
                )
                setRoomData({
                  ...roomData,
                  room_type: selectedType.roomType,
                  program_type: selectedType.programType,
                  room_type_uuid: selectedType.uuid,
                  program_type_uuid: selectedType.programTypeUUID,
                })
              }}
              selection
              // value="02-123"
              options={options}
            />
          </Grid.Column>
        </Grid.Row>
      )}
    </>
  )
}
export default withFloorMap()(SpaceType)
